import client from '../config/client';

const services = {
  info: client.service('/info'),
  users: client.service('/users'),
  schoolyears: client.service('/schoolyears'),
  families: client.service('/families'),
  students: client.service('/students'),
  classrooms: client.service('/classrooms'),
  userFamily: client.service('/user-family'),
  authManagement: client.service('/authManagement'),
  classroomStudent: client.service('/classroom-student'),
  classroomTeacher: client.service('/classroom-teacher'),
  notifications: client.service('/notifications'),
  myNotifications: client.service('/notification-to'),
  studentAllergens: client.service('/student-allergen'),
  dailyControl: client.service('/student-daily-control'),
  agendaMedicament: client.service('/child-agenda-medication'),
  agendaFamilia: client.service('/child-agenda'),
  studentAgenda: client.service('/student-agenda'),
  studentAttendance: client.service('/student-attendance'),
  utiles: client.service('/utiles')
};

export default services;
